import PageHero from "@/components/layout/PageHero";
import RiskTypes from "@/components/sections/RiskTypes";
import SolutionAreas from "@/components/sections/SolutionAreas";
import Platform from "@/components/sections/Platform";
import RiskEstimator from "@/components/sections/RiskEstimator";
import CTA from "@/components/sections/CTA";
import { IMAGES } from "@/lib/constants";

export default function WhatWeDo() {
    return (
        <div data-testid="page-what-we-do">
            <PageHero
                title={<>Four instruments. <em className="text-gold not-italic font-light">One operating layer</em> for carbon-linked risk.</>}
                lead="From baseline inventory to abatement roadmap — a read-only intelligence stack that sits above your existing systems, purpose-built for banks, regulators, and the MSMEs that anchor their portfolios."
                image={IMAGES.dashboard}
            />
            <RiskTypes />
            <SolutionAreas />
            <Platform />
            <RiskEstimator />
            <CTA />
        </div>
    );
}
